import { useState, useEffect } from "react";
import { useCallback } from "react";

const useWindowSize = () => {
	const isClient = typeof window === "object";

	const getSize = useCallback(() => {
		return {
			width: isClient ? window.innerWidth : undefined,
			height: isClient ? window.innerHeight : undefined 
		};
	});

	const [windowSize, setWindowSize] = useState(getSize);

	const handleResize = useCallback(() => {
		setWindowSize(getSize());
	});

	useEffect(() => {
		if (!isClient) {
			return false;
		}

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	});

	return windowSize;
};

export default useWindowSize;
